import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export type UserContext = "coach" | "customer";

interface IInitialState {
  activeContext: UserContext | null;
  isContextSwitching: boolean;
}

const initialState: IInitialState = {
  activeContext: null,
  isContextSwitching: false,
};

export const userContextSlice = createSlice({
  name: "userContext",
  initialState,
  reducers: {
    setUserContext: (state, action: PayloadAction<UserContext>) => {
      state.activeContext = action.payload;
    },
    resetUserContext: (state) => {
      state.activeContext = null;
    },
    userContextLogoutReset: (state) => {
      state.activeContext = null;
      state.isContextSwitching = false;
    },
    setContextSwitching: (state, action: PayloadAction<boolean>) => {
      state.isContextSwitching = action.payload;
    },
  },
});

export const {
  setUserContext,
  resetUserContext,
  userContextLogoutReset,
  setContextSwitching,
} = userContextSlice.actions;

export default userContextSlice.reducer;
